import { PERMISSIONS } from '../utils/constants';
import clienteAxios from './Axios.jsx';

export const createProcessService = async (payload) => {
  try {
    const response = await Promise.resolve(
      clienteAxios.post('/process', {
        processName: payload.name,
        description: payload.description,
        descriptorP: payload.descriptor,
        implementationId: payload.implementationId,
        processDefinitionId: payload.definitionId,
        color: payload.color,
        associatedAspects: payload.associatedAspects,
        pathFolder: payload.pathFolder,
        baseTable: payload.baseTable,
        stateId: 0,
        taskCompletionAlert: payload.taskCompletionAlert,
      })
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getFilteringVars = async (processSelected) => {
  try {
    const key = `process_name=${processSelected}`;
    const response = await Promise.resolve(clienteAxios.get(`/processFilteringVars/process?${key}`));
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getSearchVarsByProcess = async (processSelected) => {
  try {
    const response = await Promise.resolve(clienteAxios.get(`/process/processSearchVars/${processSelected}`));
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getAnonymProcessesService = async () => {
  try {
    const response = await Promise.resolve(clienteAxios.get(`/anonym/process`));
    return response;
  } catch (error) {
    throw new Error(error);
  }
};
export const getProcessByIdService = async (payload) => {
  try {
    let response;
    if (payload.isLogged) {
      response = await Promise.resolve(clienteAxios.get(`/process/${payload.id}`));
    } else {
      response = await Promise.resolve(clienteAxios.get(`/anonym/process/${payload.id}`));
    }

    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const modifyProcessActivation = async (payload) => {
  try {
    const response = await Promise.resolve(
      clienteAxios.put(`/processState/${payload.processId}`, {
        stateId: payload.newState,
        descriptorP: payload.descriptorP,
      })
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getAllProcessService = async (payload) => {
  let key;
  if (payload) {
    const { page, PAGESIZE } = payload;
    if (page !== undefined && PAGESIZE !== undefined) {
      const offset = page * PAGESIZE;
      if (payload.filterData) {
        key = `limit=${PAGESIZE}&offset=${offset}&${payload.filterData}`;
      } else if (payload.filters) {
        key = `limit=${PAGESIZE}&offset=${offset}&${payload.filters}`;
      } else {
        key = `limit=${PAGESIZE}&offset=${offset}`;
      }
    } else if (payload.filterData) {
      key = `${payload.filterData}`;
    }
    if (payload.filterPermission) {
      key += `&filterPermission=1`;
    }
  }
  try {
    let response;
    if (key) {
      response = await Promise.resolve(clienteAxios.get(`/process?${key}`));
    } else {
      response = await Promise.resolve(clienteAxios.get('/process'));
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getAllProcessByPermissionService = async (permission) => {
  const key = `processFilter=&stateId=0&filterPermission=${permission}`;
  try {
    const response = await Promise.resolve(clienteAxios.get(`/process?${key}`));
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const updateProcessService = async (payload) => {
  try {
    const data = {
      processName: payload.name,
      description: payload.description,
      descriptorP: payload.descriptorP,
      implementationId: payload.implementationId,
      processDefinitionId: payload.definitionId,
      color: payload.color,
      associatedAspects: payload.associatedAspects,
      pathFolder: payload.pathFolder,
      baseTable: payload.baseTable,
      version: payload.version,
      anonymCreation: payload.anonymCreation,
      urlRedirect: payload.urlRedirect,
      logo: payload.logo,
      callbackEndpointId: payload.callbackEndpointId,
      externalCreation: payload.externalCreation,
      taskCompletionAlert: payload.taskCompletionAlert,
    };
    const response = await Promise.resolve(clienteAxios.put(`/process/${payload.processId}`, data));
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const deleteProcessByIdService = async (id) => {
  try {
    const response = await Promise.resolve(clienteAxios.delete(`/process/${id}`));
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getProcessByDescriptorService = async (descriptorP, page, PAGESIZE) => {
  try {
    let offset;
    let key = `descriptorP=${descriptorP}`;
    if (page !== undefined && PAGESIZE !== undefined) {
      offset = page * PAGESIZE;
      key = `descriptorP=${descriptorP}&limit=${PAGESIZE}&offset=${offset}`;
    }
    const response = await Promise.resolve(clienteAxios.get(`/processVersions?${key}`));
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const createNewVersionService = async (payload) => {
  const { id } = payload;
  try {
    const response = await Promise.resolve(clienteAxios.post(`/process/newVersion/${id}`));
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const checkProcessValidation = async (payload) => {
  try {
    const { impId, defId } = payload;
    const response = await Promise.resolve(clienteAxios.get(`/process/validate/${impId}/${defId}/`));
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getProcessImage = async (payload) => {
  try {
    const { implid, defid } = payload;
    const response = await Promise.resolve(clienteAxios.get(`/process/image/${implid}/${defid}/`));
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getFilteredProjects = async (payload) => {
  try {
    const body = {
      vars: Object.fromEntries(payload.filterVarsValues),
      process: payload.processSelected,
      identifier: payload.identifier,
    };
    const response = await Promise.resolve(clienteAxios.post(`/process/projects`, body));
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getProcessTaskInstance = async (payload) => {
  try {
    const { containerId, processInstanceId } = payload;
    const response = await Promise.resolve(
      clienteAxios.get(`/process/getTaskInstance/${containerId}/${processInstanceId}/`)
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getProcessTaskInstaceImage = async (payload) => {
  try {
    const { containerId, processInstanceId } = payload;
    const response = await Promise.resolve(
      clienteAxios.get(`/process/getProcessTaskInstace/${containerId}/${processInstanceId}/`)
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getProcessTaskInstaceHistory = async (payload) => {
  try {
    const { containerId, processInstanceId } = payload;
    const response = await Promise.resolve(
      clienteAxios.get(`/process/getProcessInstanceHistory/${containerId}/${processInstanceId}/`)
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getProcessDataByFilter = async (payload) => {
  try {
    const response = await Promise.resolve(clienteAxios.post(`/process/searchByFilter`, payload));
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const updateTaskCandidatesInstance = async (data, taskId, processId = -1) => {
  try {
    const response = await Promise.resolve(
      clienteAxios.put(`/process/taskInstanceCandidates/${taskId}/processId/${processId}`, data)
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getProcessInstances = async (payload) => {
  try {
    const { processId, descriptorP, instanceIdentifier, processStatus, creatorUserId, creatorName, page, pageSize } =
      payload;
    const response = await Promise.resolve(
      clienteAxios.get(`/process/instances`, {
        params: {
          processId,
          descriptorP,
          instanceIdentifier,
          processStatus,
          creatorUserId,
          creatorName,
          page,
          pageSize,
        },
      })
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getCreationProcesses = async () => {
  try {
    const response = await Promise.resolve(clienteAxios.get(`/process/processByPermission/${PERMISSIONS.CREATION}`));
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getSearchProcesses = async () => {
  try {
    const response = await Promise.resolve(clienteAxios.get(`/process/processByPermission/${PERMISSIONS.SEARCH}`));
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getMonitoringProcesses = async () => {
  try {
    const response = await Promise.resolve(clienteAxios.get(`/process/processByPermission/${PERMISSIONS.MONITORING}`));
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getReassignProcesses = async () => {
  try {
    const response = await Promise.resolve(clienteAxios.get(`/process/processByPermission/${PERMISSIONS.REASSIGN}`));
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getTaskPendingUsersProcess = async () => {
  try {
    const response = await Promise.resolve(
      clienteAxios.get(`/process/processByPermission/${PERMISSIONS.TASK_PENDING_USER}`)
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getHistoryProcess = async () => {
  try {
    const response = await Promise.resolve(
      clienteAxios.get(`/process/processByPermission/${PERMISSIONS.PROCESS_HISTORY}`)
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getMonthlyManagementProcess = async () => {
  try {
    const response = await Promise.resolve(
      clienteAxios.get(`/process/processByPermission/${PERMISSIONS.MONTHLY_MANAGEMENT}`)
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getMonthlyManagementProcessByArea = async () => {
  try {
    const response = await Promise.resolve(
      clienteAxios.get(`/process/processByPermission/${PERMISSIONS.MONTHLY_MANAGEMENT_BY_AREA}`)
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getProcessReportsMunicipality = async () => {
  try {
    const response = await Promise.resolve(
      clienteAxios.get(`/process/processByPermission/${PERMISSIONS.PROCESS_REPORTS_MUNICIPALITY}`)
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getAuditoriaProcesses = async () => {
  try {
    const response = await Promise.resolve(clienteAxios.get(`/process/processByPermission/${PERMISSIONS.AUDITORIA}`));
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getMonitoringVariable = async (descriptorP, processId) => {
  try {
    let key = '';
    if (processId) {
      key = `?process_id=${processId}`;
    }
    const response = await Promise.resolve(
      clienteAxios.get(`process/monitoringVariable/processDescriptor/${descriptorP}${key}`)
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const importProcessSchema = async (processId, file) => {
  try {
    const formData = new FormData();
    formData.append('processSchema', file);

    const response = await Promise.resolve(
      clienteAxios.post(`/process/${processId}/importSchema`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const exportProcessSchema = async (processId) => {
  try {
    const response = await Promise.resolve(clienteAxios.get(`/process/${processId}/exportSchema`));
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getBpmProcessVariables = async (processId) => {
  try {
    const response = await Promise.resolve(clienteAxios.get(`/process/${processId}/getBpmProcessVariables`));
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const exportFilesPost = async (payload) => {
  try {
    const response = await Promise.resolve(
      clienteAxios.post(
        `/${payload.type}/export`,
        { ...payload.filters, columnsExport: payload.columnsExport, isExcel: payload.isExcel },
        { responseType: 'arraybuffer' }
      )
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const exportCompleteReport = async (payload) => {
  try {
    const response = await Promise.resolve(
      clienteAxios.post(
        `/${payload.type}/export`,
        { ...payload.filters, columnsExport: payload.columnsExport, isExcel: payload.isExcel },
        { responseType: 'arraybuffer' }
      )
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const getProcessGeoPoints = async (filter) => {
  try {
    const response = await Promise.resolve(clienteAxios.post(`/process/getProcessGeoPoints`, filter));
    return response;
  } catch (error) {
    throw new Error(error);
  }
};
